import { Component } from 'react';
import "./NotFound.css";

class NotFound extends Component {
    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="error-template">
                            <h1>
                                Oops!
                            </h1>
                            <h2>
                                Erreur 404 - Page introuvable
                            </h2>
                            <div className="error-details">
                                {"Désolé, une erreur s'est produite, la page demandée est introuvable"}
                            </div>
                            <div className="error-actions">
                                <a href="/" className="btn btn-primary btn-lg">
                                    <span className="glyphicon glyphicon-home"></span>
                                    Accueil
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NotFound;
